import { render, staticRenderFns } from "./GenLinkParcel.vue?vue&type=template&id=cb926b42&scoped=true&"
import script from "./GenLinkParcel.vue?vue&type=script&lang=js&"
export * from "./GenLinkParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb926b42",
  null
  
)

export default component.exports